import type * as React from 'react';
import type { JSX } from 'react';
import cx from 'classnames';

interface Alert {
  className: string;
  backgroundColor: string;
  textColor: string;
}

export const alertTypes: { [key: string]: string } = {
  success: 'bg-ok-soft text-ok',
  info: 'bg-accent-soft text-accent-text',
  warning: 'bg-review-soft text-review',
  danger: 'bg-danger-soft text-danger',
};

interface AlertProps {
  type: string;
  children: JSX.Element | string;
}

const Alert: React.FC<AlertProps> = ({ type, children }: AlertProps) => {
  const alertType = alertTypes[type];
  return (
    <div>
      <div className={cx('my-5 rounded-xl p-4 text-15', alertType)}>
        {children}
      </div>
    </div>
  );
};
export default Alert;
